<template>
  <div>
    <SetHeader />
    <div class="peopleType">
      <a-tabs
        v-model:activeKey="activePeopleType"
        v-show="[2, '2'].includes(queryParams.type)"
        @change="changeActivePeopleType"
        hide-add
        type="editable-card"
        @edit="onEdit"
      >
        <a-tab-pane :key="2" tab="ALL" :closable="false"></a-tab-pane>
        <a-tab-pane
          :key="14"
          tab="Local Sale"
          closable
          v-if="localVisible"
        ></a-tab-pane>
        <a-tab-pane
          :key="15"
          tab="Local Sale美东"
          closable
          v-if="localEastVisible"
        ></a-tab-pane>
        <a-tab-pane
          :key="16"
          tab="Local Sale美西"
          closable
          v-if="localWestVisible"
        ></a-tab-pane>
        <template #tabBarExtraContent>
          <a-dropdown>
            <a-button type="link">添加人群</a-button>
            <template #overlay>
              <a-menu>
                <a-menu-item :disabled="isPeopleTypeDisabled(14)">
                  <a-button
                    type="text"
                    size="small"
                    :disabled="isPeopleTypeDisabled(14)"
                    @click="addLocal(14)"
                  >
                    Local Sale</a-button
                  >
                </a-menu-item>
                <a-menu-item :disabled="isPeopleTypeDisabled(15)">
                  <a-button
                    type="text"
                    size="small"
                    :disabled="isPeopleTypeDisabled(15)"
                    @click="addLocal(15)"
                  >
                    Local Sale美东</a-button
                  >
                </a-menu-item>
                <a-menu-item :disabled="isPeopleTypeDisabled(16)">
                  <a-button
                    type="text"
                    size="small"
                    :disabled="isPeopleTypeDisabled(16)"
                    @click="addLocal(16)"
                  >
                    Local Sale美西</a-button
                  >
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-tabs>
      <a-radio-group
        style="margin: 0 15px;"
        :value="langCode"
        @change="radioChange"
        v-if="langDic && langDic.length"
      >
        <a-radio-button
          v-for="item in langDic"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </a-radio-button>
      </a-radio-group>
    </div>

    <TopBar v-if="queryParams.type - 0 === 2" />
    <PopUp v-if="queryParams.type - 0 === 1" ref="popUpRef" />
    <Activity v-if="queryParams.type - 0 === 8"></Activity>
    <div class="h100"></div>
    <div class="bottomBar">
      <div class="fr">
        <a-button type="default" class="mr10" @click="() => jumpPage()"
          >取消</a-button
        >
        <a-button type="primary" @click="() => save()">保存</a-button>
      </div>
    </div>
  </div>
  <BigPic />
</template>
<script>
import {
  toRefs,
  reactive,
  onMounted,
  provide,
  computed,
  h,
  ref,
  nextTick
} from 'vue'
import { useRouter, useRoute } from 'vue-router'
import SetHeader from './components/SetHeader.vue'
import TopBar from './components/TopBar.vue'
import PopUp from './components/PopUp.vue'
import BigPic from './components/BigPic.vue'
import Activity from './components/Activity.vue'
import useAPI from 'UseApi'
import { message, notification } from 'ant-design-vue'
import { formRequest } from 'cupshe-axios'
import { cloneDeep, pick } from 'lodash-es'
import { popupWindow_base_effectivePageList_get } from '@/server/modules/12797'
const {
  commonConfig_popup_detail_post_,
  // commonConfig_topbar_detail_post_,
  commonConfig_popup_save_post_,
  commonConfig_topbar_v2_save_post_,
  commonConfig_activity_save_post_,
  commonConfig_activity_detail_post_,
  commonConfig_page_enum_post_,
  common_lang_get_,
  commonConfig_topbar_v2_detail_post_
} = useAPI(null, [7056, 3426, 10352, 7741, 12797])
import dayjs from 'dayjs'

export default {
  components: {
    SetHeader,
    TopBar,
    PopUp,
    BigPic,
    Activity
  },
  setup() {
    const localPeopleTypeMap = {
      14: 'localVisible',
      15: 'localEastVisible',
      16: 'localWestVisible'
    }
    const localPeopleTypes = [14, 15, 16]
    const popUpRef = ref()

    const state = reactive({
      activePeopleType: 2,
      localVisible: false,
      localEastVisible: false,
      localWestVisible: false,
      effectivePageList: [],
      getPeopleTypeIndex: peopleType =>
        state.dataAll.findIndex(item => item?.peopleType - 0 === peopleType),
      upsertPeopleTypeData: (peopleType, data) => {
        const index = state.getPeopleTypeIndex(peopleType)
        const row = { ...cloneDeep(data), peopleType }
        if (index > -1) {
          state.dataAll[index] = row
        } else {
          state.dataAll.push(row)
        }
      },
      removePeopleTypeData: peopleType => {
        const index = state.getPeopleTypeIndex(peopleType)
        if (index > -1) {
          state.dataAll.splice(index, 1)
        }
      },
      setPeopleTypeVisible: (peopleType, visible) => {
        const key = localPeopleTypeMap[peopleType]
        if (key) {
          state[key] = visible
        }
      },
      isPeopleTypeDisabled: peopleType => {
        const siteId = `${state.queryParams?.siteId ??
          state.route?.query?.siteId ??
          ''}`
        if (siteId === '1') {
          return peopleType === 14
        }
        return [15, 16].includes(peopleType)
      },
      resetLangToDefault: () => {
        state.langCode =
          state.defaultLanguageCode || state.langDic?.[0]?.value || ''
      },
      syncCurrentTopbarToDataAll: () => {
        const currentPeopleType =
          state.topbarParams?.peopleType - 0 || state.activePeopleType - 0 || 2
        state.upsertPeopleTypeData(currentPeopleType, {
          ...cloneDeep(state.topbarParams),
          peopleType: currentPeopleType
        })
      },
      addLocal: peopleType => {
        if (state.isPeopleTypeDisabled(peopleType)) {
          return
        }
        const localData = state.dataAll.find(
          item => item?.peopleType - 0 === peopleType
        )
        if (localData) {
          state.setPeopleTypeVisible(peopleType, true)
          state.activePeopleType = peopleType
          state.resetLangToDefault()
          state.topBarSetParams(peopleType)
          return
        }
        state.syncCurrentTopbarToDataAll()
        const allData = state.dataAll.find(item => item?.peopleType - 0 === 2)
        const allStatus =
          allData?.status ??
          state.topbarParams?.status ??
          state.resetTopbarParams?.status
        state.upsertPeopleTypeData(peopleType, {
          ...cloneDeep(state.resetTopbarParams),
          id: null,
          status: allStatus
        })
        state.setPeopleTypeVisible(peopleType, true)
        state.activePeopleType = peopleType
        state.resetLangToDefault()
        state.topBarSetParams(peopleType)
      },
      changeStatus: e => {
        localPeopleTypes.forEach(peopleType => {
          const index = state.getPeopleTypeIndex(peopleType)
          if (index > -1) {
            state.dataAll[index].status = e.target.value
          }
        })
      },
      onEdit: (targetKey, action) => {
        if (action !== 'remove') {
          return
        }
        const peopleType = targetKey - 0
        if (!localPeopleTypes.includes(peopleType)) {
          return
        }
        state.setPeopleTypeVisible(peopleType, false)
        state.removePeopleTypeData(peopleType)
        if (state.activePeopleType - 0 === peopleType) {
          state.activePeopleType = 2
          state.resetLangToDefault()
          state.topBarSetParams(2)
        }
      },
      changeActivePeopleType: async e => {
        const peopleType = e - 0
        state.syncCurrentTopbarToDataAll()
        state.activePeopleType = peopleType
        state.resetLangToDefault()
        state.topBarSetParams(peopleType)
      },
      topBarSetParams: (e = 2) => {
        const currentData = state.dataAll.find(
          item => item?.peopleType - 0 === e
        )
        state.topbarParams = {
          ...cloneDeep(state.resetTopbarParams),
          ...cloneDeep(currentData || {}),
          peopleType: e
        }

        if (!state.topbarParams.topbarItemDTOList) {
          state.topbarParams.topbarItemDTOList = [
            {
              addButton: true,
              color: '#ffffff',
              // 颜色
              countdown: 0,
              // 0 不开启 1 开启
              endTime: null,
              // 倒计时活动结束时间
              link: null,
              // 链接
              orderNum: 0,
              // 顺序
              startTime: null,
              // 活动开始时间
              text: null,
              // 文案
              topbarConfigId: null // topbar 配置id
            }
          ]
        }
        state.topbarParams.topbarItemDTOList.forEach(item => {
          if (item.startTime) {
            item.times = [
              dayjs(item.startTime, 'YYYY-MM-DD hh:mm:ss'),
              dayjs(item.endTime, 'YYYY-MM-DD hh:mm:ss')
            ]
          } else {
            item.times = []
          }
        })
        const buttonIdx = state.topbarParams.topbarItemDTOList.findIndex(
          item => item.addButton
        )

        if (buttonIdx === -1) {
          state.topbarParams.topbarItemDTOList.splice(
            state.topbarParams.topbarItemDTOList.length,
            0,
            {
              addButton: true,
              color: '#000000',
              // 颜色
              countdown: 0,
              // 0 不开启 1 开启
              endTime: null,
              // 倒计时活动结束时间
              link: null,
              // 链接
              orderNum: 0,
              // 顺序
              startTime: null,
              // 活动开始时间
              text: null,
              // 文案
              topbarConfigId: null // topbar 配置id
            }
          )
        }
      },
      dataAll: [],
      langCode: '',
      langDic: [],
      defaultCurrency: '',
      defaultLanguageCode: '',
      defaultLanguageIndex: 0,
      common_lang_get: async () => {
        await common_lang_get_({ ...state.route.query }, state)
        const index = state.langDic.findIndex(
          v => v.value === state.defaultLanguageCode
        )
        state.defaultLanguageIndex = index > -1 ? index : 0
      },

      getEffectivePageList: async () => {
        const params = {
          brandId: state.queryParams.brandId,
          channelId: state.queryParams.channelId,
          siteId: state.queryParams.siteId,
          terminalId: state.queryParams.terminalId
        }
        const { data } = await popupWindow_base_effectivePageList_get(params)
        state.effectivePageList = data.map(i => ({
          label: i.pageName,
          value: String(i.pageId)
        }))
      },
      changeTabType: () => {
        setTimeout(() => {
          document.body.scrollTop = document.documentElement.scrollTop = 0
        }, 10)
      },
      inputLengthCut: (val, key, type = 1) => {
        let value = val
          .split('')
          .splice(0, 20)
          .join('')
        state[`popupSet${type}`][key] = value
      },
      lengthCut: (val, key, per, len = 20) => {
        let value = val
          .split('')
          .splice(0, len)
          .join('')
        if (!per) {
          state[key] = value
        } else {
          state[per][key] = value
        }
      },
      bigPic: null,
      visiblePic: false,
      changeVisiblePic: (visiblePic = false, bigPic = null) => {
        state.visiblePic = visiblePic
        state.bigPic = bigPic
      },
      upload: (info = null, index, terminal) => {
        state.fileList = [info.file]
        state.info = info
        state.uploadHandleChange(index, terminal)
      },
      uploadHeaders: {
        Authorization:
          localStorage.getItem('token') || '0e044f64c5364f93a5cb83731a09b8b9'
      },
      uploadHandleChange: async (index = null, terminal) => {
        const params = {
          1: 'popupSet1',
          2: 'popupSet2',
          3: 'popupSet3',
          4: 'popupSet4',
          5: 'popupSet5',
          6: 'popupSet6',
          9: 'popupSet9',
          13: 'popupSet13',
          17: 'popupSet17'
        }
        const { info } = state
        if (info && info.file) {
          const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
          const { success, retInfo, data } = await formRequest(api, {
            file: info.file
          })
          if (success) {
            const { url } = data
            const {
              file: { size }
            } = state.info
            let size_ = Math.floor(size / 1024)
            if (terminal === 'pc') {
              if (size_ > 500 && index === 6) {
                message.error('图片大小超过500k，请重新上传！')
                return
              }
              state[params[index]].pcImgUrl = url
              state[params[index]].materialIdPcImg = ''
              state[params[index]].materialSourcePcImg = ''
            } else if (terminal === 'sidebarIndividuationImage') {
              if (size_ > 20) {
                message.error('图片大小超过20k，请重新上传！')
                return
              }
              state.popupParams.sidebarIndividuationImage = url
            } else if (terminal === 'popupSet7_pc') {
              if (size_ > 500) {
                message.error('图片大小超过500k，请重新上传！')
                return
              }
              state.popupSet7.pcImgUrl = url
              state.popupSet7.materialIdPcImg = ''
              state.popupSet7.materialSourcePcImg = ''
            } else if (terminal === 'sidebarContent') {
              if (size_ > 20) {
                message.error('图片大小超过20k，请重新上传！')
                return
              }
              state.popupParams.sidebarContent = url
            } else if (terminal === 'popupSet7_m') {
              if (size_ > 300) {
                message.error('图片大小超过300k，请重新上传！')
                return
              }
              state.popupSet7.mImgUrl = url
              state.popupSet7.materialIdMImg = ''
              state.popupSet7.materialSourceMImg = ''
            } else if (terminal === '9m') {
              state[params[index]].langs.find(
                v => v.langCode === state.langCode
              ).mImgUrl = url
              state[params[index]].langs.find(
                v => v.langCode === state.langCode
              ).materialIdMImg = ''
              state[params[index]].langs.find(
                v => v.langCode === state.langCode
              ).materialSourceMImg = ''
            } else if (terminal === '9emailSuspendM') {
              state[params[index]].langs.find(
                v => v.langCode === state.langCode
              ).mEmailSuspendImgUrl = url
              state[params[index]].langs.find(
                v => v.langCode === state.langCode
              ).materialEmailSuspendIdMImg = ''
              state[params[index]].langs.find(
                v => v.langCode === state.langCode
              ).materialEmailSuspendMImg = ''
            } else if (terminal === '9smsSuspendM') {
              state[params[index]].langs.find(
                v => v.langCode === state.langCode
              ).mSmsSuspendImgUrl = url
              state[params[index]].langs.find(
                v => v.langCode === state.langCode
              ).materialSmsSuspendIdMImg = ''
              state[params[index]].langs.find(
                v => v.langCode === state.langCode
              ).materialSmsSuspendMImg = ''
            } else if (terminal === '9pc') {
              state[params[index]].langs.find(
                v => v.langCode === state.langCode
              ).pcImgUrl = url
              state[params[index]].langs.find(
                v => v.langCode === state.langCode
              ).materialIdPcImg = ''
              state[params[index]].langs.find(
                v => v.langCode === state.langCode
              ).materialSourcePcImg = ''
            } else {
              if (size_ > 300 && terminal === 'm' && index === 6) {
                message.error('图片大小超过300k，请重新上传！')
                return
              } else {
                if (size_ > 500) {
                  message.error('图片大小超过500k，请重新上传！')
                  return
                }
                state[params[index]].mImgUrl = url
                state[params[index]].materialIdMImg = ''
                state[params[index]].materialSourceMImg = ''
              }
            }
          } else {
            message.error(retInfo)
          }
        } else {
          message.info('文件未上传！')
        }
      },
      handleSubmit: (data, index = null, terminal) => {
        const params = {
          1: 'popupSet1',
          2: 'popupSet2',
          3: 'popupSet3',
          4: 'popupSet4',
          5: 'popupSet5',
          6: 'popupSet6',
          9: 'popupSet9',
          13: 'popupSet13',
          17: 'popupSet17'
        }

        if (terminal === '9m') {
          state[params[index]].langs.find(
            v => v.langCode === state.langCode
          ).mImgUrl = data.url
          state[params[index]].langs.find(
            v => v.langCode === state.langCode
          ).materialIdMImg = data?.materialNo || ''
          state[params[index]].langs.find(
            v => v.langCode === state.langCode
          ).materialSourceMImg = data?.source || ''
        } else if (terminal === '9emailSuspendM') {
          state[params[index]].langs.find(
            v => v.langCode === state.langCode
          ).mEmailSuspendImgUrl = data.url
          state[params[index]].langs.find(
            v => v.langCode === state.langCode
          ).materialEmailSuspendIdMImg = data?.materialNo || ''
          state[params[index]].langs.find(
            v => v.langCode === state.langCode
          ).materialEmailSuspendMImg = data?.source || ''
        } else if (terminal === '9smsSuspendM') {
          state[params[index]].langs.find(
            v => v.langCode === state.langCode
          ).mSmsSuspendImgUrl = data.url
          state[params[index]].langs.find(
            v => v.langCode === state.langCode
          ).materialSmsSuspendIdMImg = data?.materialNo || ''
          state[params[index]].langs.find(
            v => v.langCode === state.langCode
          ).materialSmsSuspendMImg = data?.source || ''
        } else if (terminal === '9pc') {
          state[params[index]].langs.find(
            v => v.langCode === state.langCode
          ).pcImgUrl = data.url
          state[params[index]].langs.find(
            v => v.langCode === state.langCode
          ).materialIdPcImg = data?.materialNo || ''
          state[params[index]].langs.find(
            v => v.langCode === state.langCode
          ).materialSourcePcImg = data?.source || ''
        } else if (terminal === 'popupSet7_pc') {
          state.popupSet7.pcImgUrl = data.url
          state.popupSet7.materialIdPcImg = data?.materialNo || ''
          state.popupSet7.materialSourcePcImg = data?.source || ''
        } else if (terminal === 'popupSet7_m') {
          state.popupSet7.mImgUrl = data.url
          state.popupSet7.materialIdMImg = data?.materialNo || ''
          state.popupSet7.materialSourceMImg = data?.source || ''
        } else if (terminal === 'pc') {
          state[params[index]].pcImgUrl = data.url
          state[params[index]].materialIdPcImg = data?.materialNo || ''
          state[params[index]].materialSourcePcImg = data?.source || ''
        } else if (terminal === 'm') {
          state[params[index]].mImgUrl = data.url
          state[params[index]].materialIdMImg = data?.materialNo || ''
          state[params[index]].materialSourceMImg = data?.source || ''
        }
      },
      tabType: 1,
      styleType: 1,
      // 人群与tabType组合的数据结构 样式二用的
      pepopleTabMap: {},
      pepopleTabMapKey: computed(() => {
        const peopleSupport = state.popupParams.peopleSupport
        const peopleKey = !peopleSupport ? null : state.popupParams.peopleType
        const key = `${peopleKey}-${state.tabType}`
        state?.scrollIntoView(9)
        return [20, 21, 22].includes(state.tabType) ? key : ''
      }),
      tabTypeChange: (tabType = 1) => {
        let type = tabType
        if (state.queryParams.terminalId === '2') return
        state.tabType = tabType
        if (+state.styleType === 2 && +state.tabType === 9) {
          state.tabType = 20
          type = 9
        }
        nextTick(() => {
          state.scrollIntoView(type)
        })

        // state.popupParams.popType = tabType - 0 === 1 ? 1 : 2
      },
      scrollIntoView(type) {
        // 👇 等 DOM 更新后滚动
        const el = document.querySelector(`[data-type="${type}"]`)
        if (!el) return

        el.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        })
      },
      jumpPage: () => {
        if (state.route.query?.type - 0 === 2) {
          const query = state.route.query

          state.router.push({
            path: 'TopBarList',
            query: pick(query, ['terminalId', 'brandId', 'channelId', 'siteId'])
          })
        } else {
          state.router.push({
            path: 'PublicSet',
            query: {
              ...state.route.query
            }
          })
        }
      },
      initList: async () => {
        const { type } = state.queryParams
        let params = {
          ...(type - 0 === 1 ? state.popupParams : state.topbarParams),
          ...state.queryParams
        }
        if ('lang' in params) delete params.lang
        if ('langCode' in params) delete params.langCode
        if (type - 0 === 1) {
          for (let i = 0; i < 3; i++) {
            state[`popupSet${i + 1}`] = { ...state.popupSet, type: i + 1 }
          }
        }
        if (type - 0 === 8) {
          commonConfig_page_enum_post_(params, state)
        }
        let api =
          type - 0 === 1
            ? commonConfig_popup_detail_post_
            : type - 0 === 8
            ? commonConfig_activity_detail_post_
            : commonConfig_topbar_v2_detail_post_
        await api(params, state)
        if (type - 0 === 1) {
          state.langsList = state.langDic.map(v => {
            const getLangParams = (m, flag = false, isPop9 = false) => {
              // m 为 参数，m.langs 和 数组的langCode 一直 ，返回原参和当前参的assign
              let p = m?.langs?.find(k => k.langCode === v.value) || {}
              if (state.queryParams.terminalId === '2' && p && flag) {
                const text = p.mText?.split('/&') || []
                p.mText = text[0] || ''
                p.mfText = text[1] || ''
              }
              delete p?.id
              delete p?.autoId
              p.langCode = v.value
              if (isPop9)
                m.subscriptionChannel =
                  state.queryParams.terminalId === '2'
                    ? 1
                    : m.subscriptionChannel
              return p ? { ...m, ...p } : {}
            }

            return {
              langCode: v.value,
              popupTextCouponDTOList7: state.handleCouponList(
                JSON.parse(getLangParams(state.popupSet7)?.couponList || '[]')
              ),
              popupTextCouponDTOList8: state.handleCouponList(
                JSON.parse(getLangParams(state.popupSet8)?.couponList || '[]')
              ),
              popupParams: {
                ...getLangParams(state.popupParams),
                peopleSupport:
                  state.queryParams.terminalId === '1'
                    ? state.popupParams.peopleSupport
                    : 0,
                peopleType: state.popupParams.peopleSupport === 1 ? 1 : null,
                filterUrl:
                  state.queryParams.terminalId === '1'
                    ? state.popupParams.filterUrl
                    : state.popupParams.filterUrl
                    ? [...state.popupParams.filterUrl.split(';')]
                    : [],
                popType:
                  state.queryParams.terminalId === '1'
                    ? state.popupParams.popType
                    : 5,
                userType:
                  state.queryParams.terminalId === '1'
                    ? state.popupParams.userType
                    : 4
              },
              popupSet1: getLangParams(state.popupSet1),
              popupSet2: getLangParams(state.popupSet2),
              popupSet3: getLangParams(state.popupSet3),
              popupSet4: getLangParams(state.popupSet4),
              popupSet5: getLangParams(state.popupSet5),
              popupSet6: getLangParams(state.popupSet6),
              popupSet7: getLangParams(state.popupSet7),
              popupSet8: getLangParams(state.popupSet8),
              popupSet9: getLangParams(state.popupSet9, true, true),
              popupSet10: getLangParams(state.popupSet10, true),
              popupSet11: getLangParams(state.popupSet11, true),
              popupSet12: getLangParams(state.popupSet12, true),
              popupSet13: getLangParams(state.popupSet13),
              popupSet14: getLangParams(state.popupSet14),
              popupSet15: getLangParams(state.popupSet15),
              popupSet16: getLangParams(state.popupSet16),
              popupSet17: getLangParams(state.popupSet17),
              popupSet18: getLangParams(state.popupSet18),
              popupSet19: getLangParams(state.popupSet19),
              popupSet20: getLangParams(state.popupSet20)
            }
          })

          // 查询默认语言中的值赋值给主对象
          state.radioChange({ target: { value: state.langCode } })
        } else if (type - 0 !== 8) {
          state?.topbarParams?.topbarItemDTOList?.forEach(v => {
            v.langs = state.langDic.map(k => ({
              langCode: k.value,
              ...(v?.langs?.find(m => m.langCode === k.value) || {})
            }))
            v.langs[state.defaultLanguageIndex].text = v.text
          })
        } else {
          state.activityFormData.langs = state.langDic.map(k => ({
            langCode: k.value,
            ...(state.activityFormData?.langs?.find(
              m => m.langCode === k.value
            ) || {
              pcImgUrl: '',
              mImgUrl: '',
              appImgUrl: ''
            })
          }))
          const activeDefaultLangIndex = state.activityFormData?.langs?.findIndex(
            m => m.langCode === state.defaultLanguageCode
          )
          if (activeDefaultLangIndex > -1) {
            state.activityFormData.langs[activeDefaultLangIndex].pcImgUrl =
              state.activityFormData.pcImgUrl
            state.activityFormData.langs[activeDefaultLangIndex].mImgUrl =
              state.activityFormData.mImgUrl
            state.activityFormData.langs[activeDefaultLangIndex].appImgUrl =
              state.activityFormData.appImgUrl
          }
        }
      },
      handleCouponList(arr) {
        const allNum = 2
        arr = arr.filter(item => item)
        let len = Math.max(allNum - arr.length, 0)
        while (len > 0) {
          arr.push({
            couponName: '',
            couponViceName: '',
            sort: allNum - len
          })
          len--
        }
        return arr
      },
      handlePeopleChange(e) {
        if (e === 0) {
          state.popupParams.peopleType = null
        } else {
          state.popupParams.peopleType = state.popupParams.peopleType ?? 1
        }
      },
      popupSet: {
        buttonTextTwo: null,
        buttonText: '', // 按钮文案
        cookieText: '', // cookie提示
        mImgUrl: '', //mText
        pcImgUrl: '', // 图片url-pc
        pcText: '', // 文案-pc
        mText: '', // 文案-m
        popupId: '', //popup配置
        type: '' // 弹窗类型。1.订阅弹窗默认，2.初次订阅成功，3.重新订阅成功，4.注册弹窗
      },
      popupSet1: {},
      popupSet2: {},
      popupSet3: {},
      popupSet4: {
        buttonText: '', // 按钮文案
        cookieText: '', // cookie提示
        mImgUrl: '', //mText
        pcImgUrl: '', // 图片url-pc
        pcText: '', // 文案-pc
        mText: '', // 文案-m
        popupId: '', //popup配置
        type: 4
      },
      popupSet5: {
        buttonText: '',
        type: 5
      },
      popupSet6: {
        subscriptionConfirmPcText: '', // 确认订阅文案
        buttonText: '', // 按钮文案
        checkboxPcText: '', // 勾选框文案-PC
        checkboxMText: '', // 勾选框文案-M
        checkboxDefaultChoose: 1, // 勾选框是否默认勾选
        type: 6
      },
      popupSet7: {
        subjectName: null,
        couponNum: 1,
        pcImgUrl: null,
        mImgUrl: null,
        popupTextCouponDTOList: [
          {
            couponName: '',
            couponViceName: '',
            sort: 1
          },
          {
            couponName: '',
            couponViceName: '',
            sort: 2
          }
        ]
      },
      popupSet8: {
        subjectName: null,
        couponNum: 1,
        pcImgUrl: null,
        mImgUrl: null,
        popupTextCouponDTOList: [
          {
            couponName: '',
            couponViceName: '',
            couponCode: '',
            couponCopyText: '',
            sort: 1
          },
          {
            couponName: '',
            couponViceName: '',
            couponCode: '',
            couponCopyText: '',
            sort: 2
          }
        ]
      },
      popupSet9: {},
      popupSet10: {},
      popupSet11: {},
      popupSet12: {},
      popupSet13: {},
      popupSet14: {},
      popupSet15: {},
      popupSet16: {},
      popupSet17: {},
      popupSet18: {},
      popupSet19: {},
      popupSet20: {},

      popupParams: {
        delayTime: 5,
        backColor: 'rgba(255,255,255,1)'
      },
      restPopupParams: {
        creator: null, // 创建人
        delayTime: 5, //弹窗延迟出现时间,单位秒
        filterUrl: null, // 不展示的路由：此为C端哪个页面不展示topbar，以分号分割；
        id: null, //主键id
        modifier: null, // 修改人
        oncePopPerUser: true, // 每个用户仅弹出一次- 0.否 、1. 是
        popType: 1, //弹窗类型-1.订阅弹窗、2.注册弹窗
        popupTextDTOS: [], //弹窗文案集合
        sidebarContent: null, //侧边栏内容
        sidebarType: 1, // 侧边栏类型 1.文本、2.图片
        status: 0, // 状态 -0.禁用、1.启用
        userType: 1, //触发用户类型-1.所有用户（新访+老访）、2.新用户（新访）、3.未注册用户（新访+老访的未注册用户) 4.未订阅用户、5.未登陆用户
        popFrequency: null, //一次弹窗间隔天数
        backColor: 'rgba(255,255,255,1)',
        sidebarShowCloseButton: false, //是否展示关闭按钮
        guestPopupEnable: null, //未登录弹窗启用状态-0.禁用、1.启用
        guestPopupDelayTime: null //未登录弹窗延迟出现秒数
      },
      topBarItem: {
        color: '#ffffff', // 颜色
        textColor: '#ffffff', // 颜色
        countdown: 0, // 0 不开启 1 开启
        endTime: null, // 倒计时活动结束时间
        link: null, // 链接
        orderNum: 0, // 顺序
        startTime: null, // 活动开始时间
        text: null, // 文案
        topbarConfigId: null,
        times: [], // topbar 配置id
        langs: []
        // isShow: undefined
      },
      removeTopbar: (index = 1) => {
        state.topbarParams.topbarItemDTOList.splice(index, 1)
      },
      addTopBarItem: () => {
        if (!state.topbarParams.topbarItemDTOList) {
          state.topbarParams.topbarItemDTOList = []
        }
        state.topbarParams.topbarItemDTOList.splice(
          state.topbarParams.topbarItemDTOList.length - 1,
          0,
          {
            ...state.topBarItem,
            index: state.topbarParams.topbarItemDTOList.length,
            langs: state.langDic.map(v => ({ langCode: v.value, text: '' }))
          }
        )
        // state.topbarParams.topbarItemDTOList = [
        //   ...state.topbarParams.topbarItemDTOList,
        //   { ...state.topBarItem }
        // ]
      },
      topbarParams: {
        backCol: '#000000', //背景颜色
        ceiling: true
      },
      resetTopbarParams: computed(() => {
        const langs = state.langDic.map(v => ({
          langCode: v.value,
          text: null,
          endText: null,
          startText: null
        }))
        return {
          backCol: '#000000', //背景颜色
          ceiling: true, // 是否吸顶-0.否、1.是
          creator: null, // 创建人
          filterUrl: state.queryParams?.terminalId === '1' ? null : [], // 不展示的路由：此为C端哪个页面不展示topbar，以分号分割
          id: null, // 主键id
          leftRightTime: 4, // 左右轮播时间，单位秒
          modifier: null, //修改人
          status: 0, //状态 -0.禁用、1.启用
          topbarItemDTOList: [
            {
              addButton: false,
              color: '#ffffff', // 颜色
              textColor: '#ffffff', // 颜色
              countdown: 0, // 0 不开启 1 开启
              endTime: null, // 倒计时活动结束时间
              link: null, // 链接
              orderNum: 0, // 顺序
              startTime: null, // 活动开始时间
              text: null, // 文案
              topbarConfigId: null, // topbar 配置id
              langs: cloneDeep(langs),
              index: 0
              // isShow: false
            },
            {
              addButton: true,
              color: '#ffffff', // 颜色
              textColor: '#ffffff', // 颜色
              countdown: 0, // 0 不开启 1 开启
              endTime: null, // 倒计时活动结束时间
              link: null, // 链接
              orderNum: 0, // 顺序
              startTime: null, // 活动开始时间
              text: null, // 文案
              topbarConfigId: null, // topbar 配置id
              langs: cloneDeep(langs),
              index: 1
              // isShow: false
            }
          ], // topbar子项
          upDownTime: 5, // 上下轮播时间，单位秒
          topbarStyle: 0
        }
      }),
      queryParams: {},
      route: useRoute(),
      router: useRouter(),
      activeKey: 1,
      check: 1,
      checkPic: 1,
      checkChange: (check = 1) => {
        state.check = check
      },
      checkPicChange: (checkPic = 1) => {
        state.checkPic = checkPic
      },
      popupSet6_warning: {
        pcText: '订阅文案-PC必填！', // 订阅文案-PC不能为空
        mText: '订阅文案-M必填！', // 订阅文案-M不能为空
        subscriptionConfirmPcText: '确认订阅文案必填！', // 确认订阅文案
        buttonText: '订阅按钮必填！', // 按钮文案
        checkboxPcText: '勾选框文案-PC必填！', // 勾选框文案-PC
        checkboxMText: '勾选框文案-M必填！', // 勾选框文案-M
        mImgUrl: 'm端图片未上传！',
        pcImgUrl: 'pc端图片未上传！'
      },
      //活动入口
      activityFormData: {
        id: '',
        status: 0,
        entranceUrl: '',
        timeSet: [],
        startTime: '',
        endTime: '',
        showPage: [],
        appImgUrl: '',
        pcImgUrl: '',
        mImgUrl: '',
        isAllShow: false,
        langs: null
      },
      showPageOptions: [],
      //时间
      timeChange: e => {
        state.activityFormData.startTime =
          e === null || e.length === 0
            ? null
            : e[0].format('YYYY-MM-DD HH:mm:ss')
        state.activityFormData.endTime =
          e === null || e.length === 0
            ? null
            : e[1].format('YYYY-MM-DD HH:mm:ss')
      },
      //img
      imageType: {
        pc: {
          type: 'pc',
          tip: 'PC端(三倍图) 360 * 360',
          width: 360,
          height: 360,
          size: 500
        },
        m: {
          type: 'm',
          tip: 'M端(三倍图) 180 * 180',
          width: 180,
          height: 180,
          size: 300
        },
        app: {
          type: 'app',
          tip: 'APP端(三倍图) 180 * 180',
          width: 180,
          height: 180,
          size: 300
        }
      },
      popSetWarning: {
        pcText: '订阅成功文案-PC',
        mText: '订阅成功文案-M',
        buttonText: '订阅成功按钮',
        primaryButtonText: '订阅成功主按钮文案',
        primaryButtonLink: '订阅成功主按钮跳转链接',
        secondaryButtonText: '订阅成功次按钮文案',
        secondaryButtonLink: '订阅成功次按钮跳转链接'
      },
      popsetWarningList: ['pcText', 'mText', 'buttonText'],
      defaultWarningList: [
        'pcText',
        'mText',
        'checkboxPcText',
        'checkboxMText',
        'buttonText'
      ],

      defaultAppWarningList: ['mText', 'checkboxMText', 'buttonText'],

      popsetAppWarningList: ['mText', 'buttonText'],

      defaultPopSetWarning: {
        pcText: '订阅文案-PC',
        mText: '订阅文案-M',
        checkboxPcText: '勾选框文案-PC',
        checkboxMText: '勾选框文案-M',
        buttonText: '订阅按钮'
      },

      defaultAppPopSetWarning: {
        pcText: '订阅文案-PC',
        mText: '订阅文案-App',
        checkboxPcText: '勾选框文案-PC',
        checkboxMText: '勾选框文案-App',
        buttonText: '订阅按钮'
      },

      apppopSetWarning: {
        pcText: '订阅成功文案-PC',
        mText: '订阅成功文案-App',
        buttonText: '订阅成功按钮',
        primaryButtonText: '订阅成功主按钮文案',
        primaryButtonLink: '订阅成功主按钮跳转链接',
        secondaryButtonText: '订阅成功次按钮文案',
        secondaryButtonLink: '订阅成功次按钮跳转链接'
      },

      //全选
      isAllShowChange: () => {
        state.activityFormData.showPage = []
      },
      //删除照片
      delActivityImg: e => {
        e === '1'
          ? (state.activityFormData.langs[
              state.activityFormData.langs.findIndex(
                v => v.langCode === state.langCode
              )
            ].pcImgUrl = '')
          : e === '2'
          ? (state.activityFormData.langs[
              state.activityFormData.langs.findIndex(
                v => v.langCode === state.langCode
              )
            ].mImgUrl = '')
          : (state.activityFormData.langs[
              state.activityFormData.langs.findIndex(
                v => v.langCode === state.langCode
              )
            ].appImgUrl = '')
      },
      //获取照片url
      setImgUrl: (type, url) => {
        type === '1'
          ? (state.activityFormData.langs[
              state.activityFormData.langs.findIndex(
                v => v.langCode === state.langCode
              )
            ].pcImgUrl = url)
          : type === '2'
          ? (state.activityFormData.langs[
              state.activityFormData.langs.findIndex(
                v => v.langCode === state.langCode
              )
            ].mImgUrl = url)
          : (state.activityFormData.langs[
              state.activityFormData.langs.findIndex(
                v => v.langCode === state.langCode
              )
            ].appImgUrl = url)
      },
      currentLangIndex: 0,
      langsList: [],
      radioChange: e => {
        if (state.queryParams?.type - 1 === 0) {
          // 如果是切换过来的话，把需要的同步数据到每个langsList内，此处目的是为了补平代码设计上的缺陷
          const beforeIndex = state.langsList?.findIndex(
            v => v.langCode === state.langCode
          )
          state.langsList.forEach(item => {
            const propData = JSON.parse(
              JSON.stringify(state.langsList[beforeIndex].popupParams)
            )
            delete propData?.sidebarContent
            delete propData?.sidebarIndividuationImage
            delete propData?.sidebarType
            delete propData?.popupTextCouponDTOList
            item.popupParams = { ...item.popupParams, ...propData }
          })
          // 更新真正的 langCode 再执行操作
          state.langCode = e.target.value
          const index = state.langsList?.findIndex(
            v => v.langCode === state.langCode
          )
          if (index > -1) {
            // 赋值当前地址给reactive 下面循环赋值同理
            state.popupParams = state.langsList[index]?.popupParams
            for (let i = 1; i < 9; i++) {
              state[`popupSet${i}`] = state.langsList[index][`popupSet${i}`]
            }
          }
          state.popupParams.backColor =
            state.popupParams.backColor || 'rgba(255,255,255,1)'
        } else if (e?.target) {
          state.langCode = e.target.value
        }
      },
      getStyle2SubmitParams(
        keys = [
          'peopleType',
          'type',
          'popupId',
          'mImgUrl',
          'pcImgUrl',
          'mEmailSuspendImgUrl',
          'materialEmailSuspendIdMImg',
          'materialEmailSuspendMImg',
          'mSmsSuspendImgUrl',
          'materialSmsSuspendIdMImg',
          'materialSmsSuspendMImg'
        ]
      ) {
        const arrs = []

        Object.keys(state.pepopleTabMap).forEach(key => {
          const {
            mImgUrl,
            pcImgUrl,
            mEmailSuspendImgUrl,
            materialEmailSuspendIdMImg,
            materialEmailSuspendMImg,
            mSmsSuspendImgUrl,
            materialSmsSuspendIdMImg,
            materialSmsSuspendMImg
          } = state.pepopleTabMap[key]
          const langs = state.langDic.map(lang => {
            return {
              langCode: lang.value,
              ...(state.pepopleTabMap[key][lang.value] || {}),
              mImgUrl,
              pcImgUrl,
              mEmailSuspendImgUrl,
              materialEmailSuspendIdMImg,
              materialEmailSuspendMImg,
              mSmsSuspendImgUrl,
              materialSmsSuspendIdMImg,
              materialSmsSuspendMImg
            }
          })

          const data = { langs }
          keys.forEach(k => {
            if (state.pepopleTabMap[key][k] !== undefined) {
              data[k] = state.pepopleTabMap[key][k]
            }
          })

          arrs.push(data)
        })

        return arrs
      },
      save: async () => {
        const { type } = state.queryParams
        if (state.popupParams.sidebarType - 0 === 3) {
          for (let item of state.langsList) {
            const langLabel = state.langDic.find(v => v.value === item.langCode)
              ?.label
            if (['', null, false].includes(item.popupParams.sidebarContent)) {
              message.warning('多语言' + langLabel + '中的文案不能为空！')
              return
            }
          }
        }
        if (state.popupParams.popType === 3) {
          for (let item of state.langsList) {
            const itemPopupSet5 = item.popupSet5
            const itemPopupSet6 = item.popupSet6
            const langLabel = state.langDic.find(v => v.value === item.langCode)
              ?.label
            if (['', null, false].includes(itemPopupSet5.buttonText)) {
              message.warning(
                '多语言' +
                  langLabel +
                  '：订阅弹窗中Email的' +
                  '订阅按钮文案不为空！'
              )
              return
            }
            for (let [key, value] of Object.entries(state.popupSet6_warning)) {
              if (['', null, false].includes(itemPopupSet6[key])) {
                message.warning(
                  '多语言' + langLabel + '：订阅弹窗中SMS的' + value
                )
                return
              }
            }
          }
        }
        //topbar
        if (type - 0 === 2) {
          for (let i = 0; i < state.dataAll.length; i++) {
            if (
              state.topbarParams.topbarStyle === 1 &&
              state.topbarParams.topbarItemDTOList.length <= 2
            ) {
              message.warning('topbar个数不能少于两个')
              return
            }
          }
        }
        // tag
        if (state.popupParams.popType === 4) {
          for (let item of state.langsList) {
            const itemPopupSet7 = item.popupSet7
            const itemPopupSet8 = item.popupSet8
            const langLabel = state.langDic.find(v => v.value === item.langCode)
              ?.label
            if (['', null, false].includes(itemPopupSet7.subjectName)) {
              message.warning(
                '多语言' +
                  langLabel +
                  '：快捷注册弹窗中未注册的活动主题不能为空！'
              )
              return
            }

            if (['', null, false].includes(itemPopupSet7.buttonText)) {
              message.warning(
                '多语言' +
                  langLabel +
                  '：快捷注册弹窗中未注册的BUTTON名称不能为空！'
              )
              return
            }

            if (['', null, false].includes(itemPopupSet7.pcImgUrl)) {
              message.warning(
                '多语言' +
                  langLabel +
                  '：快捷注册弹窗中未注册的PC端背景图不能为空！'
              )
              return
            }

            if (['', null, false].includes(itemPopupSet7.mImgUrl)) {
              message.warning(
                '多语言' +
                  langLabel +
                  '：快捷注册弹窗中未注册的m端背景图不能为空！'
              )
              return
            }

            if (['', null, false].includes(itemPopupSet8.subjectName)) {
              message.warning(
                '多语言' +
                  langLabel +
                  '：快捷注册弹窗注册成功的活动主题不能为空！'
              )
              return
            }

            if (['', null, false].includes(itemPopupSet8.buttonText)) {
              message.warning(
                '多语言' +
                  langLabel +
                  '：快捷注册弹窗注册成功的BUTTON名称不能为空！'
              )
              return
            }

            if (['', null, false].includes(itemPopupSet8.buttonLink)) {
              message.warning(
                '多语言' +
                  langLabel +
                  '：快捷注册弹窗注册成功的BUTTON 点击跳转链接不能为空！'
              )
              return
            }
          }
        }

        if (
          state.popupParams.popType === 5 &&
          state.popupParams.peopleSupport === 0 &&
          state.queryParams.terminalId === '1'
        ) {
          const warningList = []

          state.langDic.forEach(item => {
            const langLabel = item.label

            const itemPopupSet9 = state.popupSet9.langs.find(
              v => v.langCode === item.value
            )

            const itemPopupSet10 = state.popupSet10.langs.find(
              v => v.langCode === item.value
            )
            const itemPopupSet11 = state.popupSet11.langs.find(
              v => v.langCode === item.value
            )
            const itemPopupSet12 = state.popupSet12.langs.find(
              v => v.langCode === item.value
            )

            state.defaultWarningList.forEach(i => {
              if (
                ['', null, false].includes(itemPopupSet9[i]) ||
                !itemPopupSet9[i]
              )
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中默认${state.defaultPopSetWarning[i]}不能为空！`
                })
            })

            state.popsetWarningList.forEach(i => {
              if (
                ['', null, false].includes(itemPopupSet10[i]) ||
                !itemPopupSet10[i]
              ) {
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中Email${state.popSetWarning[i]}不能为空！`
                })
              }

              if (
                ['', null, false].includes(itemPopupSet11[i]) ||
                !itemPopupSet11[i]
              ) {
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中Phone${state.popSetWarning[i]}不能为空！`
                })
              }

              if (
                ['', null, false].includes(itemPopupSet12[i]) ||
                !itemPopupSet12[i]
              ) {
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中Email+Phone${state.popSetWarning[i]}不能为空！`
                })
              }
            })
          })
          if (warningList.length)
            return message.warning(
              '多语言' + warningList[0].label + warningList[0].value
            )
        }

        if (
          state.popupParams.popType === 5 &&
          state.popupParams.peopleSupport === 0 &&
          state.queryParams.terminalId === '2'
        ) {
          const warningList = []

          state.langDic.forEach(item => {
            const langLabel = item.label

            const itemPopupSet9 = state.popupSet9.langs.find(
              v => v.langCode === item.value
            )

            const itemPopupSet10 = state.popupSet10.langs.find(
              v => v.langCode === item.value
            )
            const itemPopupSet11 = state.popupSet11.langs.find(
              v => v.langCode === item.value
            )
            const itemPopupSet12 = state.popupSet12.langs.find(
              v => v.langCode === item.value
            )

            state.defaultAppWarningList.forEach(i => {
              if (
                ['', null, false].includes(itemPopupSet9[i]) ||
                !itemPopupSet9[i]
              )
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中默认${state.defaultAppPopSetWarning[i]}不能为空！`
                })
            })

            state.popsetAppWarningList.forEach(i => {
              if (
                ['', null, false].includes(itemPopupSet10[i]) ||
                !itemPopupSet10[i]
              ) {
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中Email${state.apppopSetWarning[i]}不能为空！`
                })
              }

              if (
                ['', null, false].includes(itemPopupSet11[i]) ||
                !itemPopupSet11[i]
              ) {
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中Phone${state.apppopSetWarning[i]}不能为空！`
                })
              }

              if (
                ['', null, false].includes(itemPopupSet12[i]) ||
                !itemPopupSet12[i]
              ) {
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中Email+Phone${state.apppopSetWarning[i]}不能为空！`
                })
              }
            })
          })
          if (warningList.length)
            return message.warning(
              '多语言' + warningList[0].label + warningList[0].value
            )
        }

        if (
          state.popupParams.popType === 5 &&
          state.popupParams.peopleSupport === 1
        ) {
          const warningList = []

          state.langDic.forEach(item => {
            const langLabel = item.label

            const itemPopupSet13 = state.popupSet13.langs.find(
              v => v.langCode === item.value
            )

            const itemPopupSet14 = state.popupSet14.langs.find(
              v => v.langCode === item.value
            )
            const itemPopupSet15 = state.popupSet15.langs.find(
              v => v.langCode === item.value
            )
            const itemPopupSet16 = state.popupSet16.langs.find(
              v => v.langCode === item.value
            )

            state.defaultWarningList.forEach(i => {
              if (
                ['', null, false].includes(itemPopupSet13[i]) ||
                !itemPopupSet13[i]
              )
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中默认${state.defaultPopSetWarning[i]}不能为空！`
                })
            })

            state.popsetWarningList.forEach(i => {
              if (
                ['', null, false].includes(itemPopupSet14[i]) ||
                !itemPopupSet14[i]
              ) {
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中Email${state.popSetWarning[i]}不能为空！`
                })
              }

              if (
                ['', null, false].includes(itemPopupSet15[i]) ||
                !itemPopupSet15[i]
              ) {
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中Phone${state.popSetWarning[i]}不能为空！`
                })
              }

              if (
                ['', null, false].includes(itemPopupSet16[i]) ||
                !itemPopupSet16[i]
              ) {
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中Email+Phone${state.popSetWarning[i]}不能为空！`
                })
              }
            })
          })
          if (warningList.length)
            return message.warning(
              '新访' + '多语言' + warningList[0].label + warningList[0].value
            )
        }

        if (
          state.popupParams.popType === 5 &&
          state.popupParams.peopleSupport === 1
        ) {
          const warningList = []

          state.langDic.forEach(item => {
            const langLabel = item.label

            const itemPopupSet17 = state.popupSet17.langs.find(
              v => v.langCode === item.value
            )

            const itemPopupSet18 = state.popupSet18.langs.find(
              v => v.langCode === item.value
            )
            const itemPopupSet19 = state.popupSet19.langs.find(
              v => v.langCode === item.value
            )
            const itemPopupSet20 = state.popupSet20.langs.find(
              v => v.langCode === item.value
            )

            state.defaultWarningList.forEach(i => {
              if (
                ['', null, false].includes(itemPopupSet17[i]) ||
                !itemPopupSet17[i]
              )
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中默认${state.defaultPopSetWarning[i]}不能为空！`
                })
            })

            state.popsetWarningList.forEach(i => {
              if (
                ['', null, false].includes(itemPopupSet18[i]) ||
                !itemPopupSet18[i]
              ) {
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中Email${state.popSetWarning[i]}不能为空！`
                })
              }

              if (
                ['', null, false].includes(itemPopupSet19[i]) ||
                !itemPopupSet19[i]
              ) {
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中Phone${state.popSetWarning[i]}不能为空！`
                })
              }

              if (
                ['', null, false].includes(itemPopupSet20[i]) ||
                !itemPopupSet20[i]
              ) {
                warningList.push({
                  label: langLabel,
                  value: `：订阅弹窗配置：Email+Phone中Email+Phone${state.popSetWarning[i]}不能为空！`
                })
              }
            })
          })
          if (warningList.length)
            return message.warning(
              '老访' + '多语言' + warningList[0].label + warningList[0].value
            )
        }
        let popupSet7 = null
        let popupSet8 = null
        let popupTextDTOS = []

        if (type - 0 === 1) {
          popupSet7 = {
            ...state.popupSet7,
            ...state.langsList[state.defaultLanguageIndex].popupSet7,
            popupTextCouponDTOList:
              state.langsList[state.defaultLanguageIndex]
                .popupTextCouponDTOList7,
            langs: state.langsList.map(v => {
              v.popupTextCouponDTOList7.length = state.popupSet7.couponNum
              return {
                ...v.popupSet7,
                popupTextCouponDTOList: v.popupTextCouponDTOList7
              }
            })
          }
          popupSet8 = {
            ...state.popupSet8,
            ...state.langsList[state.defaultLanguageIndex].popupSet8,
            popupTextCouponDTOList:
              state.langsList[state.defaultLanguageIndex]
                .popupTextCouponDTOList8,
            langs: state.langsList.map(v => {
              v.popupTextCouponDTOList8.length = state.popupSet8.couponNum
              return {
                ...v.popupSet8,
                popupTextCouponDTOList: v.popupTextCouponDTOList8
              }
            })
          }
          if (popupSet7.couponNum === 1) {
            popupSet7.popupTextCouponDTOList = [
              popupSet7.popupTextCouponDTOList[0]
            ]
          }

          if (popupSet8.couponNum === 1) {
            popupSet8.popupTextCouponDTOList = [
              popupSet8.popupTextCouponDTOList[0]
            ]
          }
          if (
            [2, 4].includes(state.popupSet9.associatedActivity) &&
            !state.popupSet9.activityData
          ) {
            message.warning(
              '请填写 订阅弹窗配置：Email+Phone 默认选项下的关联活动ID'
            )
            return
          }
          if (
            state.styleType === 2 &&
            popUpRef.value &&
            popUpRef.value.validateSmsStyle2
          ) {
            try {
              await popUpRef.value.validateSmsStyle2()
            } catch (err) {
              return
            }
          }

          const style2TextDTO = state.getStyle2SubmitParams()

          popupTextDTOS = [
            {
              ...state.popupSet1,
              ...state.langsList[0].popupSet1,
              langs: state.langsList.map(v => v.popupSet1)
            },
            {
              ...state.popupSet2,
              ...state.langsList[0].popupSet2,
              langs: state.langsList.map(v => v.popupSet2)
            },
            {
              ...state.popupSet3,
              ...state.langsList[0].popupSet3,
              langs: state.langsList.map(v => v.popupSet3)
            },
            {
              ...state.popupSet4,
              ...state.langsList[0].popupSet4,
              langs: state.langsList.map(v => v.popupSet4)
            },
            {
              ...state.popupSet5,
              ...state.langsList[0].popupSet5,
              langs: state.langsList.map(v => v.popupSet5)
            },
            {
              ...state.popupSet6,
              ...state.langsList[0].popupSet6,
              langs: state.langsList.map(v => v.popupSet6)
            },
            popupSet7,
            popupSet8,
            {
              ...state.popupSet9,
              ...(() => {
                const defaultLang = state.popupSet9.langs?.find(
                  v => v.langCode === state.defaultLanguageCode
                )
                if (!defaultLang) return {}
                return {
                  mEmailSuspendImgUrl: defaultLang.mEmailSuspendImgUrl,
                  materialEmailSuspendIdMImg:
                    defaultLang.materialEmailSuspendIdMImg,
                  materialEmailSuspendMImg:
                    defaultLang.materialEmailSuspendMImg,
                  mSmsSuspendImgUrl: defaultLang.mSmsSuspendImgUrl,
                  materialSmsSuspendIdMImg:
                    defaultLang.materialSmsSuspendIdMImg,
                  materialSmsSuspendMImg: defaultLang.materialSmsSuspendMImg
                }
              })(),
              langs:
                state.queryParams.terminalId === '1'
                  ? state.popupSet9.langs
                  : state.popupSet9.langs.map(i => ({
                      ...i,
                      mText: `${i.mText}/&${i.mfText}`
                    }))
            },
            {
              ...state.popupSet10,
              langs:
                state.queryParams.terminalId === '1'
                  ? state.popupSet10.langs
                  : state.popupSet10.langs.map(i => ({
                      ...i,
                      mText: `${i.mText}/&${i.mfText}`
                    }))
            },
            {
              ...state.popupSet11,
              langs:
                state.queryParams.terminalId === '1'
                  ? state.popupSet11.langs
                  : state.popupSet11.langs.map(i => ({
                      ...i,
                      mText: `${i.mText}/&${i.mfText}`
                    }))
            },
            {
              ...state.popupSet12,
              langs:
                state.queryParams.terminalId === '1'
                  ? state.popupSet12.langs
                  : state.popupSet12.langs.map(i => ({
                      ...i,
                      mText: `${i.mText}/&${i.mfText}`
                    }))
            },
            { ...state.popupSet13, peopleType: 1 },
            { ...state.popupSet14, peopleType: 1 },
            { ...state.popupSet15, peopleType: 1 },
            { ...state.popupSet16, peopleType: 1 },
            { ...state.popupSet17, peopleType: 0 },
            { ...state.popupSet18, peopleType: 0 },
            { ...state.popupSet19, peopleType: 0 },
            { ...state.popupSet20, peopleType: 0 },
            ...style2TextDTO
          ]
        }
        state.dataAll?.forEach(item => {
          item.topbarItemDTOList = item.topbarItemDTOList?.filter(
            item => !item.addButton
          )
        })
        //activity
        if (type - 0 === 8) {
          for (let item of state?.activityFormData?.langs) {
            if (state.queryParams.terminalId === '1') {
              if (!item.pcImgUrl || !item.mImgUrl) {
                message.warning(
                  `多语言${
                    state.langDic?.find(v => v.value === item.langCode)?.label
                  }下的图片不能为空`
                )
                return
              }
            }
            if (state.queryParams.terminalId === '2') {
              if (!item.appImgUrl) {
                message.warning(
                  `多语言${
                    state.langDic?.find(v => v.value === item.langCode)?.label
                  }下的图片不能为空`
                )
                return
              }
            }
          }

          if (
            !state.activityFormData.timeSet ||
            !state.activityFormData.timeSet.length
          ) {
            message.warning('请选择活动开始、结束时间')
            return
          }
          if (
            !state.activityFormData.showPage.length &&
            !state.activityFormData.isAllShow
          ) {
            message.warning('请选择展示页面')
            return
          }
        }
        // 这个state.langsList[0] 应该.find拿defaultLangCode ，先写0
        let params = {
          ...(type - 0 === 1
            ? {
                ...state.popupParams,
                ...(state.langsList[0].popupParams || {}),
                langs: state.langsList.map(v => ({
                  langCode: v?.langCode,
                  autoId: v?.popupParams?.autoId,
                  sidebarType: v?.popupParams?.sidebarType,
                  sidebarIndividuationImage:
                    v?.popupParams?.sidebarIndividuationImage,
                  sidebarContent: v?.popupParams?.sidebarContent
                })),
                filterUrl:
                  state.queryParams.terminalId === '1'
                    ? state.popupParams.filterUrl
                    : state.popupParams.filterUrl.join(';')
              }
            : type - 0 === 8
            ? {
                ...state.activityFormData,
                ...(state.activityFormData?.langs?.find(
                  v => v?.langCode === state.langCode
                ) || {})
              }
            : {
                ...state.topbarParams,
                topbarItemDTOList: state.topbarParams?.topbarItemDTOList?.map(
                  v => ({
                    ...v,
                    text: v?.langs?.[state.defaultLanguageIndex]?.text
                  })
                )
              }),
          popupTextDTOS: type - 0 === 1 ? popupTextDTOS : null,
          terminalId: state.queryParams?.terminalId,
          brandId: state.queryParams?.brandId,
          channelId: state.queryParams?.channelId,
          siteId: state.queryParams?.siteId
        }
        // const clearCodeList = params.popupTextDTOS.some(
        //   item => item.type === 9 && item.associatedActivity !== 1
        // )
        if (type - 0 === 1) {
          // 一键注册勾选状态有值
          // Email+Phone type：9 不区分人群

          // 是否区分新老访
          if (params.peopleSupport === 1) {
            // 区分新老访

            if (
              params.popupTextDTOS.some(
                item => item.type === 9 && item.peopleType === 1
              )
            ) {
              let msg = []
              params.popupTextDTOS.forEach(i => {
                if (i.type === 9 && i.peopleType === 1) {
                  if (
                    i.quickRegisterCheckStatus === '0' ||
                    i.quickRegisterCheckStatus === '1'
                  ) {
                    // 创建语言字典的Set以提高查找效率
                    const langDicSet = new Set(state.langDic.map(f => f.value))
                    // 使用filter方法替代嵌套循环，提高性能
                    const langList = i.langs
                      .filter(lang => langDicSet.has(lang.langCode))
                      .map(lang => ({ ...lang }))
                    langList.forEach(lang => {
                      if (!lang.quickRegisterText) {
                        msg.push(
                          `【${lang.langCode}】新访人群，一键注册引导文案为空`
                        )
                      }
                    })
                  }
                }
              })
              if (msg.length > 0) {
                notification['error']({
                  message: h(
                    'div',
                    { style: { fontSize: '15px', fontWeight: 'bold' } },
                    '请补充一键注册引导文案'
                  ),
                  description: h(
                    'div',
                    msg.map((i, index) =>
                      h(
                        'div',
                        { key: index, style: { marginBottom: '4px' } },
                        `${index + 1}. ${i}`
                      )
                    )
                  )
                })
                return
              }
            }
            if (
              params.popupTextDTOS.some(
                item => item.type === 9 && item.peopleType === 0
              )
            ) {
              let msg = []
              params.popupTextDTOS.forEach(i => {
                if (i.type === 9 && i.peopleType === 0) {
                  if (
                    i.quickRegisterCheckStatus === '0' ||
                    i.quickRegisterCheckStatus === '1'
                  ) {
                    // 创建语言字典的Set以提高查找效率
                    const langDicSet = new Set(state.langDic.map(f => f.value))
                    // 使用filter方法替代嵌套循环，提高性能
                    const langList = i.langs
                      .filter(lang => langDicSet.has(lang.langCode))
                      .map(lang => ({ ...lang }))
                    langList.forEach(lang => {
                      if (!lang.quickRegisterText) {
                        msg.push(
                          `【${lang.langCode}】老访人群，一键注册引导文案为空`
                        )
                      }
                    })
                  }
                }
              })
              if (msg.length > 0) {
                notification['error']({
                  message: h(
                    'div',
                    { style: { fontSize: '15px', fontWeight: 'bold' } },
                    '请补充一键注册引导文案'
                  ),
                  description: h(
                    'div',
                    msg.map((i, index) =>
                      h(
                        'div',
                        { key: index, style: { marginBottom: '4px' } },
                        `${index + 1}. ${i}`
                      )
                    )
                  )
                })
                return
              }
            }
            if (
              params.popupTextDTOS.some(
                item =>
                  item.type === 9 &&
                  item.associatedActivity !== 1 &&
                  item.peopleType === 0
              )
            ) {
              params.popupTextDTOS.forEach(item => {
                if (
                  (item.type === 10 || item.type === 11 || item.type === 12) &&
                  item.peopleType === 0
                ) {
                  item.langs.forEach(lang => {
                    lang.benefitCouponCodeList = []
                  })
                }
              })
            }
            if (
              params.popupTextDTOS.some(
                item =>
                  item.type === 9 &&
                  item.associatedActivity !== 1 &&
                  item.peopleType === 1
              )
            ) {
              params.popupTextDTOS.forEach(item => {
                if (
                  (item.type === 10 || item.type === 11 || item.type === 12) &&
                  item.peopleType === 1
                ) {
                  item.langs.forEach(lang => {
                    lang.benefitCouponCodeList = []
                  })
                }
              })
            }
          } else {
            // 不区分新老访
            if (
              params.popupTextDTOS.some(
                item =>
                  item.type === 9 &&
                  item.peopleType !== 1 &&
                  item.peopleType !== 0
              )
            ) {
              let msg = []
              params.popupTextDTOS.forEach(i => {
                if (i.type === 9 && i.peopleType !== 1 && i.peopleType !== 0) {
                  if (
                    i.quickRegisterCheckStatus === '0' ||
                    i.quickRegisterCheckStatus === '1'
                  ) {
                    // 创建语言字典的Set以提高查找效率
                    const langDicSet = new Set(state.langDic.map(f => f.value))
                    // 使用filter方法替代嵌套循环，提高性能
                    const langList = i.langs
                      .filter(lang => langDicSet.has(lang.langCode))
                      .map(lang => ({ ...lang }))
                    langList.forEach(lang => {
                      if (!lang.quickRegisterText) {
                        msg.push(
                          `【${lang.langCode}】未区分人群，一键注册引导文案为空`
                        )
                      }
                    })
                  }
                }
              })
              if (msg.length > 0) {
                notification['error']({
                  message: h(
                    'div',
                    { style: { fontSize: '15px', fontWeight: 'bold' } },
                    '请补充一键注册引导文案'
                  ),
                  description: h(
                    'div',
                    msg.map((i, index) =>
                      h(
                        'div',
                        { key: index, style: { marginBottom: '4px' } },
                        `${index + 1}. ${i}`
                      )
                    )
                  )
                })
                return
              }
            }
            if (
              params.popupTextDTOS.some(
                item =>
                  item.type === 9 &&
                  item.associatedActivity !== 1 &&
                  item.peopleType !== 0 &&
                  item.peopleType !== 1
              )
            ) {
              params.popupTextDTOS.forEach(item => {
                if (
                  (item.type === 10 || item.type === 11 || item.type === 12) &&
                  item.peopleType !== 0 &&
                  item.peopleType !== 1
                ) {
                  item.langs.forEach(lang => {
                    lang.benefitCouponCodeList = []
                  })
                }
              })
            }
          }
          let normalEmptyData = []
          // 订阅弹窗配置：Email+Phone筛选
          let emailPhoneList = []
          if (params.peopleSupport === 1) {
            emailPhoneList = params.popupTextDTOS.filter(v => {
              return (
                (v.type === 10 && (v.peopleType === 0 || v.peopleType === 1)) ||
                (v.type === 11 && (v.peopleType === 0 || v.peopleType === 1)) ||
                (v.type === 12 && (v.peopleType === 0 || v.peopleType === 1))
              )
            })
            emailPhoneList.forEach(item => {
              let typeName = ''
              let peopleTypeName = ''
              if (item.peopleType === 0) {
                peopleTypeName = '老访'
              }
              if (item.peopleType === 1) {
                peopleTypeName = '新访'
              }
              if (item.type === 10) {
                typeName = 'Email'
              } else if (item.type === 11) {
                typeName = 'Phone'
              } else if (item.type === 12) {
                typeName = 'Email+Phone'
              }
              // 创建语言字典的Set以提高查找效率
              const langDicSet = new Set(state.langDic.map(f => f.value))
              // 使用filter方法替代嵌套循环，提高性能
              const langList = item.langs
                .filter(lang => langDicSet.has(lang.langCode))
                .map(lang => ({ ...lang }))
              langList.forEach(lang => {
                if (
                  lang.benefitCouponCodeList &&
                  lang.benefitCouponCodeList.length > 0
                ) {
                  lang.benefitCouponCodeList.forEach((coupon, index) => {
                    coupon.sort = index
                    if (!coupon.couponCode || !coupon.couponDesc) {
                      normalEmptyData.push(
                        `(${lang.langCode})${peopleTypeName}，${typeName}权益信息。`
                      )
                    }
                  })
                }
              })
            })
          } else {
            emailPhoneList = params.popupTextDTOS.filter(v => {
              return (
                (v.type === 10 && v.peopleType !== 0 && v.peopleType !== 1) ||
                (v.type === 11 && v.peopleType !== 0 && v.peopleType !== 1) ||
                (v.type === 12 && v.peopleType !== 0 && v.peopleType !== 1)
              )
            })
            emailPhoneList.forEach(item => {
              let typeName = ''
              if (item.type === 10) {
                typeName = 'Email'
              } else if (item.type === 11) {
                typeName = 'Phone'
              } else if (item.type === 12) {
                typeName = 'Email+Phone'
              }
              // 创建语言字典的Set以提高查找效率
              const langDicSet = new Set(state.langDic.map(f => f.value))
              // 使用filter方法替代嵌套循环，提高性能
              const langList = item.langs
                .filter(lang => langDicSet.has(lang.langCode))
                .map(lang => ({ ...lang }))
              langList.forEach(lang => {
                if (
                  lang.benefitCouponCodeList &&
                  lang.benefitCouponCodeList.length > 0
                ) {
                  lang.benefitCouponCodeList.forEach((coupon, index) => {
                    coupon.sort = index
                    if (!coupon.couponCode || !coupon.couponDesc) {
                      normalEmptyData.push(
                        `(${lang.langCode})未区分人群，${typeName}权益信息`
                      )
                    }
                  })
                }
              })
            })
          }
          if (normalEmptyData.length > 0) {
            notification['error']({
              message: h(
                'div',
                { style: { fontSize: '15px', fontWeight: 'bold' } },
                '【Email+Phone弹窗】权益信息不完整'
              ),
              description: h(
                'div',
                normalEmptyData.map((msg, index) =>
                  h(
                    'div',
                    { key: index, style: { marginBottom: '4px' } },
                    `${index + 1}. ${msg}`
                  )
                )
              )
            })
            return
          }
        }

        type - 0 === 1 && delete params.peopleType

        let api =
          type - 0 === 1
            ? commonConfig_popup_save_post_
            : type - 0 === 8
            ? commonConfig_activity_save_post_
            : commonConfig_topbar_v2_save_post_
        if (type - 0 === 2) {
          state.upsertPeopleTypeData(state.activePeopleType - 0, {
            ...params
          })
          for (let i = 0; i < state.dataAll.length; i++) {
            state.dataAll[i] = {
              ...state.dataAll[i],
              topbarItemDTOList: state.dataAll[i]?.topbarItemDTOList?.map(
                v => ({
                  ...v,
                  text: v?.langs?.[state.defaultLanguageIndex]?.text
                })
              ),
              popupTextDTOS: null,
              terminalId: state.queryParams?.terminalId,
              brandId: state.queryParams?.brandId,
              channelId: state.queryParams?.channelId,
              siteId: state.queryParams?.siteId
            }
          }
        }
        api(params, state)
      }
    })

    provide('initState', state)
    onMounted(async () => {
      state.topbarParams = state.resetTopbarParams
      state.queryParams = state.route.query
      await state.common_lang_get()
      state.restPopupParams.langs = state.langDic.map(v => ({
        ...state.restPopupParams,
        langCode: v.value
      }))
      state.initList()
      state.tabType = state.queryParams?.terminalId === '1' ? 1 : 9
      state.getEffectivePageList() && state.queryParams?.terminalId === '2'
    })
    return {
      ...toRefs(state),
      popUpRef
    }
  }
}
</script>
<style>
@font-face {
  font-family: 'Muli-ExtraBold';
  src: url('https://cdn-image.kapeixi.cn/web/46e5a7eb-2b54-4ab9-805c-157cbba63070/Satoshi-Black.woff2');
}

.Muli-ExtraBold,
.ql-font-Muli-ExtraBold {
  font-family: Muli-ExtraBold;
}

@font-face {
  font-family: 'Note-Light';
  src: url('https://cdn-shopify.cupshe.com/shopify/b7c1df24-f396-4a08-a8e7-55a09664f1e4/Note-Light.otf');
}

.Note-Light,
.ql-font-Note-Light {
  font-family: Note-Light;
}

@font-face {
  font-family: 'Muli-Bold';
  src: url('https://cdn-image.kapeixi.cn/web/c8fca30d-913f-49af-931c-c8142f02d1ef/Satoshi-Bold.woff2');
}

.Muli-Bold,
.ql-font-Muli-Bold {
  font-family: Muli-Bold;
}

@font-face {
  font-family: 'Muli-SemiBold';
  src: url('https://cdn-image.kapeixi.cn/web/316fb9cc-e896-49bb-a52c-f14e9eab02e8/Satoshi-Medium.woff2');
}

.Muli-SemiBold,
.ql-font-Muli-SemiBold {
  font-family: Muli-SemiBold;
}

@font-face {
  font-family: 'Muli-Light';
  src: url('https://cdn-image.kapeixi.cn/web/ca5162f5-22ec-4bca-9686-2efac5d29604/Satoshi-Regular.woff2');
}

.AvenirNext-Regular,
.ql-font-AvenirNext-Regular {
  font-family: Muli-Light;
}

@font-face {
  font-family: Note-Regular;
  src: url(https://cdn-shopify.cupshe.com/shopify/d163e64d-cf1f-4521-8b24-69531bc66138/Note-Regular.otf);
}

.EditorNote-Regular,
.ql-font-EditorNote-Regular {
  font-family: Note-Regular;
}
</style>
<style scoped>
.bottomBar {
  position: fixed;
  left: 0;
  bottom: 0;
  background: #ffffff;
  z-index: 999;
  padding: 10px;
  width: calc(100%);
  border-top: 1px solid #f8f8f8;
}
</style>
<style>
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='8px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='8px']::before {
  content: '8px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='10px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='10px']::before {
  content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='12px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='12px']::before {
  content: '12px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='14px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='14px']::before {
  content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='16px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='16px']::before {
  content: '16px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='18px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='18px']::before {
  content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='20px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='20px']::before {
  content: '20px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='22px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='22px']::before {
  content: '22px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='24px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='24px']::before {
  content: '24px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='26px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='26px']::before {
  content: '26px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='28px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='28px']::before {
  content: '28px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='30px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='30px']::before {
  content: '30px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='32px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='32px']::before {
  content: '32px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='34px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='34px']::before {
  content: '34px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='36px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='36px']::before {
  content: '36px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='38px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='38px']::before {
  content: '38px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='40px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='40px']::before {
  content: '40px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='45px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='45px']::before {
  content: '45px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='50px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='50px']::before {
  content: '50px';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Muli-ExtraBold']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Muli-ExtraBold']::before {
  content: 'AvenirNext-Bold';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Muli-Bold']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Muli-Bold']::before {
  content: 'AvenirNext-Demi';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Muli-SemiBold']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Muli-SemiBold']::before {
  content: 'AvenirNext-Medium';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Muli-Light']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Muli-Light']::before {
  content: 'AvenirNext-Regular';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Note-Light']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Note-Light']::before {
  content: 'Editor’s Note-Regular';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Note-Regular']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Note-Regular']::before {
  content: 'EditorNote-Regular';
}

/**设置默认字体显示
**/
.ql-container {
  font-size: 16px;
}

.peopleType {
  background: #fff;
  margin: 15px 15px -15px 15px;
  padding: 10px;
}
</style>
